import { useAppSelector } from 'app';
import { selectAppDevice } from 'slice';
import { DEVICES } from 'utils';

import EntityCardSkeletonDesktop from './EntityCardSkeletonDesktop';
import EntityCardSkeletonMobile from './EntityCardSkeletonMobile';

const EntityCardSkeleton = () => {
  const appDevice = useAppSelector(selectAppDevice);

  const renderElements = {
    [DEVICES.DESKTOP]: <EntityCardSkeletonDesktop />,
    [DEVICES.MOBILE]: <EntityCardSkeletonMobile />,
    [DEVICES.TABLET]: <EntityCardSkeletonMobile />,
  };

  return <>{renderElements[appDevice.device]}</>;
};

export default EntityCardSkeleton;
